"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safari = exports.internetExplorer = exports.firefox = exports.edgeUWP = exports.chrome = void 0;
var _navigator = navigator,
    userAgent = _navigator.userAgent;
var firefox = /Firefox\//.test(userAgent);
exports.firefox = firefox;
var edgeUWP = /Edge\//.test(userAgent);
exports.edgeUWP = edgeUWP;
var chrome = !edgeUWP && /Chrome\//.test(userAgent);
exports.chrome = chrome;
var internetExplorer = /Trident\//.test(userAgent);
exports.internetExplorer = internetExplorer;
var safari = !(chrome || edgeUWP || firefox || internetExplorer);
exports.safari = safari;